export default __webpack_public_path__ + "imgs/like-true.b61d119b5f76819c52f9d490178ad7cb.svg";